export class VcaPlanAcknowledgement {
  constructor(
    public readonly employeeId: string,
    public readonly acknowledgedAt: Date,
  ) {
  }

  static fromJson(json: any): VcaPlanAcknowledgement {
    return new VcaPlanAcknowledgement(
      json['employee_id'],
      new Date(json['acknowledged_at']),
    )
  }
}

export class VcaPlan {
  constructor(
    public readonly id: string,
    public readonly projectId: string,
    public readonly filename: string,
    public readonly uploadedByEmployeeId: string,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
    public readonly downloadUrl: string,
    public readonly acknowledgements: VcaPlanAcknowledgement[],
  ) {
  }

  static fromJson(json: any): VcaPlan {
    return new VcaPlan(
      json['id'],
      json['project_id'],
      json['filename'],
      json['uploaded_by_employee_id'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
      json['download_url'],
      (json['acknowledgements'] ?? []).map((a: any) => VcaPlanAcknowledgement.fromJson(a)),
    )
  }
}
